import { render, staticRenderFns } from "./Comparison.vue?vue&type=template&id=ccf55dc6&scoped=true&"
import script from "./Comparison.vue?vue&type=script&lang=js&"
export * from "./Comparison.vue?vue&type=script&lang=js&"
import style0 from "./Comparison.vue?vue&type=style&index=0&id=ccf55dc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf55dc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ccf55dc6')) {
      api.createRecord('ccf55dc6', component.options)
    } else {
      api.reload('ccf55dc6', component.options)
    }
    module.hot.accept("./Comparison.vue?vue&type=template&id=ccf55dc6&scoped=true&", function () {
      api.rerender('ccf55dc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/tenders/Comparison.vue"
export default component.exports